const F = {
  black: {
    DEFAULT: "#000000",
    1: "#222529",
    2: "#363b41",
    3: "#3d4349",
    4: "#656a6e",
    5: "#636d77"
  },
  white: {
    DEFAULT: "#FFFFFF",
    1: "#fdfdfd",
    2: "#fbfbfb",
    3: "#f8f8f8",
    4: "#f2f2f2",
    5: "#ecedee",
    6: "#dedede",
    7: "#b4b7b9",
    8: "#818385",
    9: "#707375"
  },
  blue: {
    1: "#E6F0FB",
    2: "#CDE0F7",
    3: "#B4D1F4",
    4: "#9BC1F0",
    5: "#69A3E8",
    6: "#3784E1",
    7: "#0565D9",
    8: "#0451AE",
    9: "#033D82",
    10: "#022857",
    11: "#021E41",
    12: "#01142B"
  },
  red: {
    1: "#FFF4F4",
    2: "#F8CDCD",
    3: "#F5B4B4",
    4: "#F19B9B",
    5: "#EB6868",
    6: "#E43636",
    7: "#DD0404",
    8: "#B10303",
    9: "#850202",
    10: "#580202",
    11: "#420101",
    12: "#2C0101"
  },
  green: {
    1: "#F4FDE9",
    2: "#E8FCD3",
    3: "#E1FBC5",
    4: "#BBE293",
    5: "#ADD682",
    6: "#9ECA70",
    7: "#458108",
    8: "#376706",
    9: "#1C3403",
    10: "#1C3403",
    11: "#152702",
    12: "#0E1A02"
  },
  orange: {
    1: "#FFEFEA",
    2: "#FFC1AC",
    3: "#FEA182",
    4: "#FE8259",
    5: "#FE632F",
    6: "#CC4F26",
    7: "#9A3C1C",
    8: "#692813",
    9: "#371509"
  },
  pink: {
    1: "#FAE8F4",
    2: "#F0BBDE",
    3: "#EBA5D3",
    4: "#E077BE",
    5: "#D64AA8",
    6: "#CC1D92",
    7: "#A31775",
    8: "#7A1158",
    9: "#520C3A"
  },
  purple: {
    1: "#F4EDFC",
    2: "#DDC8F5",
    3: "#D2B6F2",
    4: "#BC92EB",
    5: "#A56DE5",
    6: "#8F49DE",
    7: "#723AB2",
    8: "#562C85",
    9: "#45206D"
  }
};
export {
  F as default
};
